import { Component, OnInit, AfterViewInit, PLATFORM_ID, Inject } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { LinkService } from '../../_services/langhfre.service';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { WINDOW } from '@ng-toolkit/universal';
import * as $ from 'jquery';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})
export class FAQComponent implements OnInit {

  
  constructor(private titleService: Title,
    private metaTagService: Meta,
    @Inject(PLATFORM_ID) private platformId: Object,
    private LinkService: LinkService,
    @Inject(WINDOW) private window: Window,
    ) { }

    ngOnInit() {
      this.titleService.setTitle('Trinka帮助中心——问与答');
      this.metaTagService.updateTag({ name: 'description', content: "查看有关Trinka的常见问题解答，轻松解决您的大多数问题。" });
      this.metaTagService.updateTag({ property: 'og:title', content: 'Trinka帮助中心——问与答' });
      this.metaTagService.updateTag({ property: 'og:description', content: '查看有关Trinka的常见问题解答，轻松解决您的大多数问题。' });
      this.metaTagService.updateTag({ property: 'og:url', content: 'https://trinka.enago.cn/faqs' });
      this.metaTagService.updateTag({ property: 'og:type', content: 'website' });
      this.metaTagService.updateTag({ name: 'language', content: 'zh-cn' });
      this.LinkService.addTag({ rel: 'canonical', href: 'https://trinka.enago.cn/faqs' });
      this.LinkService.addTag({ rel: 'alternate', hreflang: 'x-default', href: 'https://www.trinka.ai/faqs' });
      this.LinkService.addTag({ rel: 'alternate', hreflang: 'en-us', href: 'https://www.trinka.ai/faqs' });
      this.LinkService.addTag({ rel: 'alternate', hreflang: 'ja-jp', href: 'https://www.trinka.ai/jp/faqs' });
      this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-cn', href: 'https://trinka.enago.cn/faqs' });
      this.LinkService.addTag({ rel: 'alternate', hreflang: 'zh-tw', href: 'https://www.trinka.ai/tw/faqs' });
      this.LinkService.addTag({ rel: 'alternate', hreflang: 'ko-kr', href: 'https://www.trinka.ai/kr/faqs' });
      this.LinkService.addTag({ rel: 'alternate', hreflang: 'es-es', href: 'https://www.trinka.ai/es/faqs' });
      this.LinkService.addTag({ rel: 'alternate', hreflang: 'pt-pt', href: 'https://www.trinka.ai/pt/faqs' });
    }
    gotoTop() {
      if (isPlatformBrowser(this.platformId)) {
        $.getScript('../../../assets/js/wisepop.js', function () { });
        this.window.scroll({
          top: 450,
          left: 0,
          behavior: 'smooth'
        });
      }
    }

}
